import { ILocationService, IRootScopeService } from 'angular';

function eventsHandler($location: ILocationService, $rootScope: IRootScopeService): void {

    function redirectToAuth(endpoint: string): void {
        const redirect = encodeURIComponent($location.url());
        $location.path('/auth_redirect').search({ redirect: redirect, endpoint: endpoint });
    }

    $rootScope.$on('maintenanceMode', () => {
        redirectToAuth('login');
    });

}

eventsHandler.$inject = ['$location', '$rootScope']

export { eventsHandler }
